module.exports = __webpack_public_path__ + "static/media/chat-case.f2dbedb7.svg";